<template>
	<div class="page">
		<!-- <div class="navLine">
			<div class="editionHeart">
				<div class="navBox">
					<div class="navItem" :class="[curNavIndex==='推荐'?'active':'']" @click="toLivingSearch('推荐')">
						推荐<img v-if="curNavIndex==='推荐'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
					<div class="navItem" :class="[curNavIndex==='英短'?'active':'']" @click="toLivingSearch('英短')">
						英短<img v-if="curNavIndex==='英短'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
					<div class="navItem" :class="[curNavIndex==='美短'?'active':'']" @click="toLivingSearch('美短')">
						美短<img v-if="curNavIndex==='美短'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
					<div class="navItem" :class="[curNavIndex==='布偶'?'active':'']" @click="toLivingSearch('布偶')">
						布偶<img v-if="curNavIndex==='布偶'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
					<div class="navItem" :class="[curNavIndex==='金毛'?'active':'']" @click="toLivingSearch('金毛')">
						金毛<img v-if="curNavIndex==='金毛'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
					<div class="navItem" :class="[curNavIndex==='雪纳瑞'?'active':'']" @click="toLivingSearch('雪纳瑞')">
						雪纳瑞<img v-if="curNavIndex==='雪纳瑞'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
					<div class="navItem" :class="[curNavIndex==='柯基'?'active':'']" @click="toLivingSearch('柯基')">
						柯基<img v-if="curNavIndex==='柯基'" src="../../../assets/img/index/navSubscript.png" class="navItemImg"/>
					</div>
				</div>
				<div class="searchBox">
					<img src="../../../assets/img/index/searchIcon.png" style="width:340px;" @click="toLivingSearch('')"/>
				</div>
			</div>
		</div> -->
		<div class="bannerLine" :style="{'background-image':'url('+backgroundImg+')'}">
			<img src="../../../assets/img/index/bannerImgPosi.png" class="bannerImgPosi">
		</div>
		<div class="titlePic">
			<span></span>
			<span>精选 ·</span>
			<span>猫猫</span>
			<span></span>
		</div>
		<div class="contentLine">
			<img class="LIcon" src="../../../assets/img/index/indexL.png" @click="click1L('1')"/>
			<img class="RIcon" src="../../../assets/img/index/indexR.png" @click="click1R('1')"/>
			<div class="editionHeart">
				<div class="goodsList" :style="{'left':left1+'px'}" ref="catList">
					<div class="goodsItem" v-for="(item,index) in catTableData" :key="index" @click="toLivingSearch(item.name)">
						<img class="goodsImg" :src="item.pic"/>
						<div class="goodsName">
							<div class="goodsNameL">{{item.name}}</div>
							<div class="goodsNameR">热销</div>
						</div>
						<div class="goodsText">{{item.remark?item.remark.substr(0,28)+'...':''}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="titlePic">
			<span></span>
			<span>精选 ·</span>
			<span>狗狗</span>
			<span></span>
		</div>
		<div class="contentLine">
			<img class="LIcon" src="../../../assets/img/index/indexL.png" @click="click2L('2')"/>
			<img class="RIcon" src="../../../assets/img/index/indexR.png" @click="click2R('2')"/>
			<div class="editionHeart">
				<div class="goodsList" :style="{'left':left2+'px'}" ref="dogList">
					<div class="goodsItem" v-for="(item,index) in dogTableData" :key="index" @click="toLivingSearch(item.name)">
						<img class="goodsImg" :src="item.pic"/>
						<div class="goodsName">
							<div class="goodsNameL">{{item.name}}</div>
							<div class="goodsNameR">热销</div>
						</div>
						<div class="goodsText">
							<span v-if="item.remark">
								<span v-if="item.remark.length>28">{{item.remark.substr(0,28)+'...'}}</span>
								<span v-else>{{item.remark}}</span>
							</span>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	 
		<!-- 装饰1 -->
		<!-- <div class="decorate1"></div> -->
		<!-- 装饰2 -->
		<!-- <img class="decorate2" src="../../../assets/img/cha.png"/> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				curNavIndex:'推荐',
				backgroundImg:'',
				
				catTableData:[],
				dogTableData:[],
				left1:0,
				left2:0,
			}
		},
		computed:{
			
		},
		mounted(){
			this.getBackgroundImg()
			this.getTableData();
		},
		methods:{
			toLivingSearch(str){
				if(str==='推荐') return ;
				this.$router.push({path:'/goods/livingSearch',query:{keyword:encodeURIComponent(str)}})
			},
			// toLivingDetail(item){
			// 	this.$router.push({path:'/goods/livingDetail?id='+item.petId})
			// },
			// changeCurNavIndex(str){
			// 	this.curNavIndex = str;
			// 	this.getTableData()
			// },
			click1L(str){
				let step = 400
				if(this.left1>(step*-1)){
					this.left1=0
				}else{
					this.left1+=step
				}
			},
			click1R(str){
				let step = 400
				let max = (this.$refs.catList.clientWidth-1200)*-1;
				if(this.left1<(max+step)){
					this.left1=max
				}else{
					this.left1-=step
				}
			},
			click2L(str){
				let step = 400
				if(this.left2>(step*-1)){
					this.left2=0
				}else{
					this.left2+=step
				}
			},
			click2R(str){
				let step = 400
				let max = (this.$refs.dogList.clientWidth-1200)*-1;
				if(this.left2<(max+step)){
					this.left2=max
				}else{
					this.left2-=step
				}
			},
			getTableData(){
				let params = {
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/Pet/category/list', params).then(res => {
					loading.close()
					if(res.code===0){
						for (let i = 0; i < res.data.length; i++) {
							if(res.data[i].applyType=="1"){
								this.catTableData=res.data[i].categoryInfos
							}else if(res.data[i].applyType=="2"){
								this.dogTableData=res.data[i].categoryInfos
							}							
						}
					}
				})
			},
			getBackgroundImg(){
				let params = {
					id:'webBanner'
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_livingMall+'/api/DataBase/config/single', params).then(res => {
					loading.close()
					if(res.code===0){
						this.backgroundImg = res.data.url;
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
.page{
	position: relative;background-color: #F6F6F8;
	// .navLine{
	// 	height: 100px;background-color: #fff;padding:30px 0 20px;box-sizing: border-box;
	// 	.editionHeart{
	// 		display: flex;justify-content: space-between;
	// 		.navBox{
	// 			display: flex;
	// 			.navItem{
	// 				font-size: 18px;color:#2A2B39;position: relative;margin-right: 64px;cursor: pointer;line-height: 45px;
	// 				&.active{
	// 					font-weight: bold;
	// 				}
	// 				.navItemImg{
	// 					width:17px;position: absolute;bottom: 8px; right: -7px;
	// 				}
	// 			}
	// 		}
	// 		.searchBox{
				
	// 		}
	// 	}
	// }
	.bannerLine{
		position: relative;height: 500px;background-repeat: no-repeat;background-size: auto 100%; background-position: center;text-align: center;
		.bannerImgPosi{
			position: absolute; bottom: -74px;right:calc(50% - 720px);
		}
	}
	.titlePic{
		text-align: center;margin:110px 0 60px;
		span:nth-child(1){
			display: inline-block;width:100px;height: 3px;background: linear-gradient(90deg, rgba(255,94,0,0) 0%, #FF5E00 100%);margin-right: 32px;
		}
		span:nth-child(2){
			display: inline-block;font-size: 32px;color:#FF5E00;margin-right: 10px;vertical-align: middle;
		}
		span:nth-child(3){
			display: inline-block;font-size: 32px;color:#2A2B39;vertical-align: middle;
		}
		span:nth-child(4){
			display: inline-block;width:100px;height: 3px;background: linear-gradient(270deg, rgba(0,0,0,0) 0%, #303042 100%);margin-left: 32px;
		}
	}
	.contentLine{
		height: 701px;position: relative;
		.LIcon{
			width:75px;height: 75px;position: absolute;left:calc(50% - 700px);top:313px;cursor: pointer;
		}
		.RIcon{
			width:75px;height: 75px;position: absolute;right:calc(50% - 700px);;top:313px;cursor: pointer;
		}
		.editionHeart{
			height: 100%;overflow:hidden;position: relative;
			.goodsList{
				display: flex;position: absolute;left:0px;transition: left .5s;height: 100%;
				.goodsItem{
					width:387px;height: 100%;cursor: pointer;margin-right: 10px;flex-shrink: 0;border-radius: 10px;overflow: hidden;font-size: 0;background-color: #fff;
					&:hover{
						background-color: rgb(252, 208, 0);
					}
					.goodsImg{
						width:100%;height: 516px;background-color: #F6F6F8;
					}
					.goodsName{
						display: flex;justify-content: space-between;padding:32px 20px 22px 20px;
						.goodsNameL{
							font-size: 32px;color:#333;
						}
						.goodsNameR{
							font-size: 21px;color:#FF6100;
						}
					}
					.goodsText{
						font-size: 21px;color:#9C9CA5;padding:0 20px;line-height: 30px;
					}
				}
			}
		}
	}
	// 装饰1
	.decorate1{
		position: absolute;width:100%;height: 431px;background-color: #F6F6F8;top:1402px;z-index: -1;
	}
	// 装饰2
	.decorate2{
		position: absolute;width:340px;top:1720px;z-index: -1;
	}
}
</style>							
